// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ace21015","552":"e53f9be1","830":"0dbf1c39"}[chunkId] + ".chunk.js";
};